import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { PageHeader, NativeSelect } from "@/components/common";
import { fmtDT } from "@/lib/format";

export default function Audit() {
  const [rows, setRows] = useState([]);
  const [entity, setEntity] = useState("");
  const [check, setCheck] = useState(null);
  useEffect(() => {
    api.get("/audit", { params: entity ? { entity } : {} }).then((r) => setRows(r.data));
  }, [entity]);
  const verify = async () => {
    try {
      const { data } = await api.get("/audit/verify");
      setCheck(data);
      toast[data.ok ? "success" : "error"](data.ok ? "Integrità verificata" : "Anomalie rilevate");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div data-testid="audit-page">
      <PageHeader title="Registro audit" subtitle="Registrazioni firmate e non modificabili di tutte le operazioni"
        actions={<>
          <NativeSelect testid="audit-filter-entity" value={entity} onChange={setEntity}>
            <option value="">Tutte le entità</option>{["auth", "work_order", "user", "commessa", "cimitero", "squadra", "toth_rule", "toth_proposal", "settings", "backup", "export", "engine"].map((e) => <option key={e} value={e}>{e}</option>)}
          </NativeSelect>
          <Button onClick={verify} className="h-10 rounded-xl font-bold" data-testid="audit-verify-button">Verifica integrità</Button>
        </>} />
      {check && (
        <div className={`mb-4 flex items-start gap-3 rounded-2xl p-4 ${check.ok ? "bg-emerald-50 text-emerald-800" : "bg-red-50 text-red-800"}`} data-testid="audit-verify-result">
          {check.ok ? <ShieldCheck className="h-5 w-5" /> : <ShieldAlert className="h-5 w-5" />}
          <div className="text-sm">{Object.entries(check.collections).map(([k, v]) => <p key={k}><b>{k}</b>: {v.total} registrazioni · firme non valide {v.invalid.length} · sequenze mancanti {v.gaps.length}</p>)}</div>
        </div>
      )}
      <div className="card-soft overflow-x-auto">
        <table className="w-full min-w-[820px] text-sm" data-testid="audit-table">
          <thead className="bg-muted/60 text-left text-xs uppercase tracking-wider text-muted-foreground"><tr><th className="px-4 py-3">#</th><th>Data e ora</th><th>Autore</th><th>Azione</th><th>Entità</th><th>Dettagli</th><th>Firma</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.id} className="border-t align-top">
              <td className="px-4 py-2 font-mono text-xs">{r.seq}</td><td className="whitespace-nowrap py-2">{fmtDT(r.at)}</td>
              <td className="py-2"><p className="font-semibold">{r.actor_name}</p><p className="text-xs text-muted-foreground">{r.actor_role} · {r.ip}</p></td>
              <td className="py-2 font-semibold">{r.action}</td><td className="py-2">{r.entity}</td>
              <td className="max-w-[320px] truncate py-2 font-mono text-xs text-muted-foreground" title={JSON.stringify(r.details)}>{JSON.stringify(r.details)}</td>
              <td className="py-2">{r.valid ? <ShieldCheck className="h-4 w-4 text-emerald-600" /> : <ShieldAlert className="h-4 w-4 text-red-600" />}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
